import { gEnums } from 'global/enums/globalEnums';
import Wrapper from 'global/wrappers/Wrapper';
import _ from 'lodash';
import { useMatchSchedule } from 'projectSpecific/sports/useHelpers/useMatchSchedule';
import { useContext, useMemo } from 'react';
import { _matchDisplayTypes, MatchContentWithProvider } from '../matches/MatchContent';
import MatchFilter from '../matches/MatchFilter';
import { SeasonMatchesContext } from 'projectSpecific/sports/cnr/contexts/SeasonMatchesContext';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';

const oppsOnly = true

export const MatchesSchedule = ({
  teamKeys = [],
  matchDisplayType = _matchDisplayTypes.teamMatches,
  matchScheduleDisplayType = gEnums.matchScheduleDisplayTypes.teamSchedule,
  parentKey = '',
  teamKey,
  matchDisplayOptions,
}) => {

  const props = {
    teamKeys,
    matchDisplayType,
    matchScheduleDisplayType,
    parentKey,
    teamKey,
    matchDisplayOptions,
  }

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matches_info, seasonMatches_info } = sportsSeason_state ?? {};
  const { matches_groupInfo, matches_matchDay } = matches_info ?? {};
  const { levelDateGroups, matches_combined } = matches_groupInfo ?? {};

  const seasonMatchesContext = useContext(SeasonMatchesContext)
  const { seasonMatches_state } = seasonMatchesContext ?? {}
  const { matchFilter } = seasonMatches_state ?? {}

  const { getScheduleMatches } = useMatchSchedule(props)

  // const xxx = getScheduleMatches(matchScheduleDisplayType, matchFilter)
  // console.log('xxx', xxx)

  const matches = useMemo(() => {
    const _matches = getScheduleMatches(matchScheduleDisplayType, matchFilter)
    const sortedTeamMatches = _.sortBy(_matches, match => new Date(match.startDate));
    console.log('sortedTeamMatches', matchScheduleDisplayType, sortedTeamMatches)
    return sortedTeamMatches
  }, [matches_combined, matchScheduleDisplayType, teamKey, matchFilter])

  const divs_matches = _.map(matches, (match) => (
    <MatchContentWithProvider
      key={match._itemKey}
      matchKey={match._itemKey}
      match={match}
      matchDisplayType={matchDisplayType}
      parentKey={parentKey}
      teamKey={teamKey}
      matchScheduleDisplayType={matchScheduleDisplayType}
      favTeamKey={match._favTeamKey} // 👈 pass it down if needed
      oppsOnly={oppsOnly}
    />
  ));

  let _cn = _.kebabCase(matchScheduleDisplayType)
  _cn += ' ' + _.kebabCase(matchDisplayType)

  if (oppsOnly &&
    (matchScheduleDisplayType === gEnums.matchScheduleDisplayTypes.teamSchedule ||
      matchScheduleDisplayType === gEnums.matchScheduleDisplayTypes.nextTeamMatch
    )) {
    _cn += ' to'
  }

  return <Wrapper
    header={matchDisplayOptions?.showMatchFilter && <MatchFilter />}
    content={divs_matches}
    css={{ container: _cn }
    }
  />
} 